import { render, staticRenderFns } from "./GithubEditor.vue?vue&type=template&id=df605194&scoped=true&"
import script from "./GithubEditor.vue?vue&type=script&lang=js&"
export * from "./GithubEditor.vue?vue&type=script&lang=js&"
import style0 from "./GithubEditor.vue?vue&type=style&index=0&id=df605194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df605194",
  null
  
)

export default component.exports